import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { Metadata } from '../../services/metadata'
import { updateDashboard, updateDashboardStatus } from '../../actions/grid'
import { StyledContent } from '../../styles/mixins'
import { StyledGrid, StyledCategoryDiv } from './style'
import ComponentContainer from '../container-component'
import ChartStock from '../chart-stock'
import ViewMarkets from '../view-markets'
import CalenderItems from '../view-calendar/calenderItems'
import { fetchCategoriesList } from '../../actions/categories'
import { Card } from 'antd';
import {Link} from 'react-router-dom';

const ResponsiveGridLayout = WidthProvider(Responsive)

type Props = {
  isUpdated: boolean,
  layouts: Object,
  onUpdateGrid: Object => void,
  onDashboardStatusChange: (boolean, null | string) => void,
  isFetching: boolean,
  isCategoryFetching: boolean,
  error: null | string
}

type State = {
  layouts: Object,
  isRiskRadarLoading: boolean,
  isRiskRadarEmpty: boolean,
  isVixViewLoading: boolean,
  isVixViewEmpty: boolean,
  isFedFocusLoading: boolean,
  isFedFocusEmpty: boolean
}

class DashboardView extends Component<Props, State> {

  state: State = {
    layouts: {},
    isRiskRadarLoading: true,
    isRiskRadarEmpty: true,
    isVixViewLoading: true,
    isVixViewEmpty: true,
    isFedFocusLoading: true,
    isFedFocusEmpty: true
  }

  componentDidMount() {

    // Set Initial Dashboard
    this.setDashboard()
  }

    componentWillMount() {
        if(!this.props.categories.length) {
            this.props.onFetchCategoriesList()
        }
    }

  handleLayoutChange = (dashboard: Layout, allLayouts: { [key: $Keys<breakpoints>]: Layout }) => {

    // save dashboard to metadata
    if (dashboard[0].h >= 6) this.props.onUpdateGrid(dashboard)
  }

  setDashboard = () => {
    // SET LOADING FOR DEMO COMPONENTS
    this.setRiskRadarLoading()
    this.setVixViewLoading()
    this.setFedFocusLoading()

    const {
      isUpdated,
      layouts,
      onDashboardStatusChange
    } = this.props

    // set dashboard loading
    onDashboardStatusChange(true, null)

    // check if redux has been updated
    if (isUpdated) {

      // add layout and remove loading
      this.setState({ layouts })
      onDashboardStatusChange(false, null)

    } else {

      const { getUser } = new Metadata()

      // check user_metadata
      getUser()
        .then((userRes: Object) => {

          // confirm metadata
          const dashboard = userRes.user_metadata.grid.dashboard

          // display grid
          if (!!dashboard && (dashboard.lg[0].h >= 6)) {

            // set data from user_metadata
            this.setState({
              layouts: {
                lg: dashboard.lg,
                md: dashboard.md,
                sm: dashboard.sm,
                xs: dashboard.xs
              }
            })

            // remove loading
            onDashboardStatusChange(false, null)

          } else {

            // set layout and remove loading
            this.setState({ layouts })
            onDashboardStatusChange(false, null)
          }
        })
        .catch((err) => {

          // hide loading and display error
          this.setState({ layouts })
          onDashboardStatusChange(false, null)
        })
    }
  }

  setRiskRadarLoading = () => {

    this.setState({ isRiskRadarLoading: true })

    setTimeout(() => {
      this.setState({
        isRiskRadarLoading: false,
        isRiskRadarEmpty: true
      })
    }, 5000)
  }

  setVixViewLoading = () => {

    this.setState({ isVixViewLoading: true })

    setTimeout(() => {
      this.setState({
        isVixViewLoading: false,
        isVixViewEmpty: true
      })
    }, 5000)
  }

  setFedFocusLoading = () => {

    this.setState({ isFedFocusLoading: true })

    setTimeout(() => {
      this.setState({
        isFedFocusLoading: false,
        isFedFocusEmpty: true
      })
    }, 5000)
  }

  render() {

    const { layouts } = this.state
    const { isFetching, error, categories, isCategoryFetching } = this.props
    let keys = ['h','i','j']
    return (
      <section>

        { (isFetching || !!error || isCategoryFetching) ?
          (
            <StyledContent>
              <ComponentContainer
                title={error || 'Loading Dashboard'}
                loading={isFetching}
                empty={!!error}
                resetData={this.setDashboard}>

                <p>Dashboard</p>
              </ComponentContainer>
            </StyledContent>
          ) :
          (
            <StyledGrid>
              <ResponsiveGridLayout
                style={{ width: 'calc(100vw - 220px)', height:"100%" }}
                className='layout'
                layouts={layouts}
                rowHeight={32}
                breakpoints={{ lg: 1260, md: 996, sm: 768, xs: 480 }}
                cols={{ lg: 24, md: 24, sm: 24, xs: 24 }}
                onLayoutChange={this.handleLayoutChange}>
                {
                  categories.map((cat, i) => (
                    <StyledCategoryDiv key={keys[i]}>
                      <Card title={<Link
                        to={cat.hassubcategories ? `/category-view/${cat.slug}` : `/categories-post/${cat.slug}`}>{cat.name}</Link>}>
                        <p>{cat.description}</p>
                      </Card>
                    </StyledCategoryDiv>
                  ))
                }
                <div key='a'>
                  <ComponentContainer
                    title='Risk Radar'
                    loading={this.state.isRiskRadarLoading}
                    empty={this.state.isRiskRadarEmpty}
                    resetData={this.setRiskRadarLoading}>

                    <h1>Risk Radar (empty)</h1>
                  </ComponentContainer>
                </div>

                <div key='b'>
                  <ComponentContainer
                    title='VIX View'
                    loading={this.state.isVixViewLoading}
                    empty={this.state.isVixViewEmpty}
                    resetData={this.setVixViewLoading}>

                    <h1>VIX View (empty)</h1>
                  </ComponentContainer>
                </div>

                <div key='c'>
                  <ComponentContainer
                    title='FED Focus'
                    loading={this.state.isFedFocusLoading}
                    empty={this.state.isFedFocusEmpty}
                    resetData={this.setFedFocusLoading}>

                    <h1>FED Focus (empty)</h1>
                  </ComponentContainer>
                </div>
                  {
                    <div>
                      <ComponentContainer
                          title='VIX View'
                          loading={this.state.isVixViewLoading}
                          empty={this.state.isVixViewEmpty}
                          resetData={this.setVixViewLoading}>

                        <h1>VIX View (empty)</h1>
                      </ComponentContainer>
                    </div>
                  }

                <div key='d'>
                  <ChartStock symbol='SPY'></ChartStock>
                </div>

                <div key='e'>
                  <ChartStock symbol='DIA'></ChartStock>
                </div>

                <div key='f'>
                  <ChartStock symbol='QQQ'></ChartStock>
                </div>

                <div key="g">
                  <ViewMarkets symbol='Markets'/>
                </div>

                <div key="k">
                  <CalenderItems/>
                </div>

              </ResponsiveGridLayout>

            </StyledGrid>
          )
        }
      </section>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  isUpdated: state.grid.isUpdated,
  layouts: state.grid.layouts,
  isFetching: state.grid.isFetching,
  error: state.grid.error,
  categories: state.categories.categoriesList.filter(x=>['Live Sessions','Education','Resources'].includes(x.name)),
  isCategoryFetching: state.categories.isFetching,
})

const mapDispatchToProps = (dispatch: Function) => ({
  onUpdateGrid(layout: Object) {
    dispatch(updateDashboard(layout))
  },
  onDashboardStatusChange(isFetching: boolean, error: null | string) {
    dispatch(updateDashboardStatus(isFetching, error))
  },
  onFetchCategoriesList: () => {
    fetchCategoriesList(dispatch)
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardView)




// WEBPACK FOOTER //
// ./src/components/view-dashboard/index.js